import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import profession from '../../Assets/Icons/profession.svg'
import income from '../../Assets/Icons/income.svg'
import date from '../../Assets/Icons/date.svg'
import stars from '../../Assets/Icons/star.svg'
import workLocation from '../../Assets/Icons/workLocation.svg'
import flawsIcon from '../../Assets/Icons/flaws.svg'
import { FaBan, FaGraduationCap } from "react-icons/fa6";
import { TbZodiacCancer } from "react-icons/tb";
import dummy from '../../Assets/Images/dummy.jpg.webp'
import { BsBookmarkHeart, BsBookmarkHeartFill } from "react-icons/bs"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { setAlert } from "../../Store/Theme/actions"
import { useTranslation } from "react-i18next"
import { MdDone } from "react-icons/md";
import { FaRegHeart } from "react-icons/fa6";
import { setCountApi } from "../../Store/Auth/actions"

const NotInterestedPage = () => {

    const [loading, setLoading] = useState(true)
    const [profileList, setProfileList] = useState([])
    const [allStars, setAllStars] = useState([])
    const [educationList, setEducationList] = useState([]);
    const [zodiacSigns, setZodiacSigns] = useState([])
    const [flaws, setFlaws] = useState([])
    const [fullEducations, setFullEducations] = useState([])
    const [status, setStatus] = useState([])
    const [occupation, setOccupation] = useState([])
    const [planActive, setPlanActive] = useState(false)
    const dispatch = useDispatch()
    const lang = useSelector((state)=>state.theme.language)
    const {t} = useTranslation()
    const countApi = useSelector((state) => state.auth.countApi)
    const userDetails = useSelector((state) => state.auth.userDetails)

    useEffect(() => {
        try {
            setLoading(true)
            axios.all([API.get('/user/notInterestedProfiles'),
            API.get('/common/getEducations'), API.get('/common/getZodiacSign'),
            API.get('/common/getAllFlaws'), API.get('/common/getStatusList'),
            API.get('/common/getOccupations'), API.get('/common/getAllStars')]).then(axios.spread((userRes, eduRes, zodiacRes, flawRes, statRes, occuRes, starRes) => {
                setProfileList(userRes.data.data)
                setPlanActive(userDetails.planActive)
                setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} ${c.specialization !== null ? `- ${c.specialization}` : ''}`, value: c._id } }))
                setFullEducations(eduRes.data.data)
                setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } }))
                setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } }))
                setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } }))
                setOccupation(occuRes.data.data)
                setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
                setLoading(false)
            }))
        } catch (err) {
            console.log(err)
        }
    }, [userDetails])

    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If birth month is after current month or same month but birth date is after current date, subtract 1
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const getFlaws = (value) => {
        return flaws.filter((x) => x.value === value)[0].text
    }

    const getQualification = (value) => {
        return educationList.filter((x) => { return x.value === value })[0].text
    }

    const notInterstProfile = (value) => {
        let apiValues = {
            profileId: value._id,
            addedBy: userDetails._id
        }
        API.post('/user/notInterest', apiValues).then((wishRes) => {
            if (wishRes.status === 200) {
                dispatch(setAlert({ title: 'Success', subtitle: 'Action successfull', type: 'success', active: true }))
                setProfileList(profileList.map((c) => {
                    if (c._id === wishRes.data.data.profileId) {
                        c.isWishlisted = false
                    }
                    return c
                }))
                dispatch(setCountApi(countApi+1))
            }
        })
    }

    return (
        <motion.div className="w-full overflow-scroll h-full py-5 flex flex-col bg-primeColor/20 gap-2">
            {
                loading ? "Loading please wait..." : <motion.div className="flex flex-col overflow-scroll md:px-20 gap-2">
                    {
                            profileList && profileList.length > 0 && profileList.map((c, i) => (
                                <motion.div key={i} className="flex flex-col rounded-lg bg-white gap-5">
                                    <motion.div className="py-5 px-2 sm:px-6 flex flex-col gap-5">
                                        <motion.div className="flex flex-col md:flex-row justify-start gap-5 ">
                                            <motion.div className="flex flex-col gap-2 relative w-[300px]">
                                                {(c?.previewUrls && c.previewUrls[0]) ? (
                                                    <img
                                                        src={(planActive || c.isDownloaded) ? c.previewUrls[0] : dummy}
                                                        className="w-[244px] h-[244px] sm:h-[244px] md:h-[244px] object-center rounded-md"
                                                        alt="Preview"
                                                    />
                                                ) : <img
                                                    src={dummy}
                                                    className="w-[244px] h-[244px] sm:h-[244px] md:h-[244px] object-center rounded-md"
                                                    alt="Preview"
                                                />}
                                            </motion.div>
                                            
                                            <motion.div className="flex flex-col w-full relative gap-1">
                                                {lang === 'en' && <p className="text-xl font-bold text-black">{c.firstName} {c.lastName} ({c.surname})</p>}
                                                {lang === 'ta' && <p className="text-xl font-bold text-black">{c.tFirstName} {c.tLastName} ({c.tSurname})</p>}
                                                <p className="text-[gray] text-md font-bold">{c.refId}</p>
                                                <motion.div className="flex flex-row flex-wrap w-full items-center gap-1">
                                                    <p>{calculateAge(c.dateOfBirth)} {t('Yrs')}</p>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    <p>{c.heightInFeet || '-'}</p>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    <span className="font-bold">{planActive || c.isDownloaded ? zodiacSigns.find(x => x.value === c.additionalInformation.zodiacSign)?.text : '----'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    <span className="font-bold">{planActive || c.isDownloaded ? allStars.find(x => x.value === c.additionalInformation.star)?.text || '---' : '----'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    <span className="font-bold">{c.educationalQualification.length > 0 ? c.educationalQualification.map(getQualification) : c.otherEducationalQualification || '--'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGrey]" />
                                                    {(planActive || c.isDownloaded) ? c.occupation !== 'undefined' && c.occupation.toString().trim().length ? c.occupation : 'Not working' : '----'}
                                                </motion.div>
                                                <motion.div className="flex flex-row relative bottom-0 w-full gap-2">
                                                    <motion.div className="w-40 flex flex-row border border-[lightGray] text-[grey] justify-center cursor-pointer items-center rounded-full px-2 py-2" onClick={() => notInterstProfile(c)}>
                                                        <MdDone className="text-grey" size={14} />&nbsp; <p className="text-md">Show Again</p>
                                                    </motion.div>
                                                    <motion.div className="w-40 flex flex-row border border-primeColor bg-primeColor text-white justify-center items-center rounded-full px-2 py-2">
                                                        <FaRegHeart className="text-white" size={14} />&nbsp;&nbsp;  <p className="text-md">Send Interest</p>
                                                    </motion.div>
                                                </motion.div>
                                            </motion.div>
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                            ))
                        }
                </motion.div>
            }
        </motion.div >
    )
}

export default NotInterestedPage